export enum DataTypesEnum {
  string = 1,
  number = 2,
  date = 3,
  image = 4,
  boolean = 5,
}

export enum TaskStatus {
  notStarted,
  inProgress,
  completed,
  isLoading,
}

export type AssetType = 'ERS' | 'HEX';

export enum EquipmentType {
  bucket = 'Bucket',
  machine = 'Machine',
  undercarriage = 'Undercarriage',
  wearPlate = 'Wear Plate',
  heelShroud = 'Heel Shroud',
  crawler = 'Crawler',
}

export enum PartName {
  driveLug = 'Drive Lug',
  pitchExtension = 'Pitch Extension',
  rollerPath = 'Roller Path',
  frontIdler = 'Front Idler',
  rearIdler = 'Rear Idler',
  tumblerEngagement = 'Tumbler Engagement',
  sideFrame = 'Side Frame',
  loadRoller = 'Load Roller',
  returnRoller = 'Return Roller',
  slider = 'Slider',
}

export enum PartCategory {
  idler = 'Idler',
  driveTumbler = 'Drive Tumbler',
  roller = 'Roller',
  shoes = 'Shoes',
  slider = 'Slider',
  groundEngagingTools = 'Ground Engaging Tools',
  wearKit = 'Wear Kit',
  structural = 'Structural',
}

export enum PartType {
  MidAdapter = 'Mid Adapter',
  UpperWingShroud = 'Upper Wing Shroud',
  WearCap = 'Wear Cap',
  LowerWingShroud = 'Lower Wing Shroud',
  Deflector = 'Deflector',
  DriveSpocket = 'Drive Spocket',
  Extension = 'Extension',
  Floor = 'Floor',
  Idler = 'Idler',
  LipShroud = 'Lip Shroud',
  Lug = 'Lug',
  Pads = 'Pads',
  Pin = 'Pin',
  WearPlate = 'Wear Plate',
  Point = 'Point',
  RollerPath = 'Roller Path',
  Rollers = 'Rollers',
  ShearBlock = 'Shear Block',
  HeelShroud = 'Heel Shroud',
  Sidewall = 'Sidewall',
  Sliders = 'Sliders',
  Spool = 'Spool',
  Straddle = 'Straddle',
  Tumbler = 'Tumbler',
  Roller = 'Roller',
  Hardware = 'Hardware',
  Slider = 'Slider',
}

export enum CategoryType {
  condition = 'AllTypes',
  changeout = 'Changeout',
}

export enum InspectionCategoryType {
  condition = 'Condition',
  changeout = 'Changeout',
  allTypes = 'AllTypes',
}
export enum InspectionCategory {
  undercarriage = 'Undercarriage',
  bucket = 'Bucket',
  allCategories = 'All Categories',
}

export const taskStatusfromProgress = (progress: number) => {
  if (progress === 100) {
    return TaskStatus.completed;
  }

  if (progress > 0) {
    return TaskStatus.inProgress;
  }

  return TaskStatus.notStarted;
};

export type DataTypesEnumType = typeof DataTypesEnum;
export type DataTypesEnumValue = DataTypesEnumType[keyof DataTypesEnumType];
export type DataTypesEnumKey = keyof DataTypesEnumType;

export enum ObservableLevelsEnum {
  asset = 1,
  equipment = 2,
  equipmentPart = 3,
  mineLocation = 4,
}

export type ObservableLevelEnumType = typeof ObservableLevelsEnum;
export type ObservableLevelEnumValue =
  ObservableLevelEnumType[keyof ObservableLevelEnumType];
export type ObservableLevelEnumKey = keyof ObservableLevelEnumType;

export function getEnumKeyByValue<T extends { [key: string]: number }>(
  enumObj: T,
  value: T[keyof T],
): keyof T | undefined {
  return Object.keys(enumObj).find((key) => enumObj[key] === value);
}

export enum InspectionStatus {
  done = 1,
  awaitingImages = 2,
  reviewing = 3,
}

export class EquipmentConsts {
  static readonly EquipmentTypes = {
    [EquipmentType.bucket]: {
      name: 'Bucket',
      id: 6,
      typeId: 1,
      category: InspectionCategory.bucket,
      categoryId: 1,
    },
  };

  static readonly EquipmentCategories = {
    [InspectionCategory.bucket]: {
      name: 'Bucket',
      id: 1,
    },
    [InspectionCategory.undercarriage]: {
      name: 'Undercarriage',
      id: 3,
    },
  };
}
